import {objetos} from 'lib.front';
import {cmps} from './constantes';

export const esquemaCampos = {
   [cmps.CODIGO]: {valor: null, error: ''},
   [cmps.DENOMINACION]: {valor: '', error: ''},
   [cmps.ES_SERVICIO]: {valor: 0, error: ''},
   [cmps.ESTADO]: {valor: 0, error: ''}
};

export const esquemaValidacion = {
   [cmps.CODIGO]: {
      requerido: true
   },
   [cmps.DENOMINACION]: {
      requerido: true
   },
   [cmps.ES_SERVICIO]: {
      requerido: false
   },
   [cmps.ESTADO]: {
      requerido: false
   }
};

export const esquemaQuery = [
   new objetos.oCampo('codigo', 'String!', true, true, true, true),
   new objetos.oCampo('denominacion', 'String', true, false, true, true),
   new objetos.oCampo('esServicio', 'Boolean', true, false, true, true),
   new objetos.oCampo('estado', 'Int', true, false, true, true)
];
